import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiPieChartComponent } from '@components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        UiPieChartComponent,
    ],
    exports: [
        UiPieChartComponent,
    ],
})
export class UiPieChartModule { }
